/**
 * Memorial Bridge — Pillar 3 copy and hub definitions.
 * Respectful remembrance; private by default until published.
 */

export const MEMORIAL_BRIDGE_TAGLINE =
  'Create a private or public tribute page from preserved stories, photos, voice memories and family tributes.';

export const MEMORIAL_BRIDGE_DASHBOARD_COPY =
  'Prepare a respectful memorial page from preserved stories, photos and voice memories — private until you publish.';

export const MEMORIAL_BRIDGE_SAFETY =
  'Private by default. Nothing is public until you publish. Tributes are moderated. Support links open external pages only — MyLegacyBridge does not collect donations.';

export const MEMORIAL_BRIDGE_DISCLAIMER =
  'Memorial Bridge is a remembrance space built from memories you already preserve. It is not a funeral shop, legal service, or fundraising platform.';

export const MEMORIAL_BRIDGE_PILLAR_LABEL = 'Memorial Bridge · Pillar 3';

export const MEMORIAL_BRIDGE_WORKSPACE_TAGLINE =
  'Prepare a tribute page from this person’s preserved stories, photos and memories.';

export const MEMORIAL_BRIDGE_PILLAR_FEATURES = [
  'Memorial pages',
  'Tribute wall',
  'QR keepsakes',
  'Music & video links',
  'External support link',
  'Privacy controls',
];

export const MEMORIAL_BRIDGE_HUB_CARDS = [
  {
    id: 'drafts',
    title: 'Private drafts',
    copy: 'Workspaces that are not public yet.',
  },
  {
    id: 'published',
    title: 'Published memorials',
    copy: 'Live tribute pages you have chosen to share.',
  },
  {
    id: 'setup',
    title: 'Set up a memorial',
    copy: 'Choose a person and enable a private draft.',
  },
  {
    id: 'qr',
    title: 'Memorial Photo Link',
    copy: 'Framed photos and tribute prints linked by dynamic /q/:shortCode after publishing.',
  },
];
